module.exports = __webpack_public_path__ + "img/404.5d31f821.svg";